<template>
  <div class="alertcontent" v-if="dialogVisible">
    <div class="alertcontentdiv">
      <div class="alertcontentdiv_head">
        <p>{{dlgTitle}}</p>
        <div>
          <i class="el-icon-close" @click="cancel"></i>
        </div>
      </div>
      <div class="alertcontentdiv_table">
        <el-table ref="multipleTable" :data="dataList"
          :highlight-current-row="true"
         tooltip-effect="dark" style="width: 100%"  border height=100%>
          <!--<div  slot="empty" v-if="emptyErrorText" :class="loading?'':'empty-err'">{{loading?'暂无数据':emptyErrorText}}</div>-->
              <el-table-column label="序号" center align="center" width='50'> 
                  <template slot-scope="scope">{{ scope.$index+1}}</template>
              </el-table-column>
              <el-table-column v-for="(item,index) in tableColumns" :key="index" :prop="item.name" align="center" :label="item.label" show-overflow-tooltip center>
                  <template slot-scope="scope">{{item.formatter ? item.formatter(scope.row[item.name], scope.row, index) : scope.row[item.name]}}</template>
              </el-table-column>
          </el-table>
      </div>
    </div>
  </div>
</template>
<script>
// import * as Api from '@/api/promotion.js'
import { methodGet } from '../../../api/request'
function requried(column) {
  throw new Error(`缺少参数[${column}]`)
}

export default {
  name: 'SearchDialog',
  props: {
    modalTitle: String,
    data: Array,
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      dlgTitle: '',
      tableColumns: [],
      dataList: []

    }
  },
  created() {
  },
  methods: {
    async open({
      dlgTitle,
      url = requried('url'),
      tableColumns = requried('tableColumns')
    }) {
      this.dlgTitle = dlgTitle;
      this.tableColumns = tableColumns;
      this.url = url
      return new Promise((resolve, reject) => {
        this.getData().then(() => {
          this.resolve = resolve;
          this.reject = reject;
        })
      })
    },
    getData() {
      this.loading = true
      return methodGet(this.url, {
      }).then(res => {
        this.loading = false
        const { code, data, message } = res
        if (code !== 0) {
          this.$message(message)
        } else {
          this.dataList = data
        }
      })
    },
    cancel() {
      this.$emit("cancel");
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
  .empty-err{
    text-align: center;
    color: red
  }
.alertcontent {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index:9;
  .alertcontentdiv {
    position: absolute;
    left: calc(50% + 90px);
    top: 50%;
    transform: translate(-50%, -50%);
    width: 900px;
    height: 660px;
    padding: 20px;
    // padding-top: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    .el-icon-close {
      font-size: 20px;
      cursor: pointer;
    }
    .alertcontentdiv_head {
      display: flex;
      align-items: center;
      position: relative;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      p {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-weight: 700;
        color: #333;
      }
      &>div {
        position: absolute;
        right: 10px;
      }
    }
    
    .alertcontentdiv_table {
      margin-top:10px;
      flex:1;
      overflow-y: auto;
    }
    .alertcontentdiv_page {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      div:nth-of-type(1) {
        font-size: 14px;
      }
      .el-pagination {
        float: right;
      }
    }
    .alertcontentdiv_buttom {
      height: 32px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/customTable/tabel-dialog.vue